import { Divider } from "@findemdev/maui";
import styled from "styled-components";

export const NavigationTabsWrapper = styled.div`
  display: flex;
  flex: 0 0 280px;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  padding: ${({ theme }) => `${theme.dimensions.spacing[3]} 20px`};
  box-sizing: border-box;
`;

export const NavigationTab = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.dimensions.spacing[2]};
  padding: ${({ theme }) => `${theme.dimensions.spacing[1]}`};
  border: none;
  border-radius: ${({ theme }) => theme.dimensions['border-radius'].md};
  background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors['blue-100'] : 'transparent'};
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors['blue-400'] : theme.colors['grey-650']};
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  text-align: left;

  &:hover {
    background-color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors['blue-100'] : theme.colors['grey-100']};
  }

  &:focus {
    outline: none;
  }
`;

export const TabIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TabText = styled.span`
  flex: 1;
`;

export const TabDivider = styled(Divider)`
  margin-top: 12px;
  margin-bottom: 12px;
`;
